import { render, staticRenderFns } from "./QuizCard.vue?vue&type=template&id=c8a7a97e"
import script from "./QuizCard.vue?vue&type=script&lang=js"
export * from "./QuizCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports